import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { CardSection } from 'components/Card';
import Message from 'components/Message';
import Button from 'components/Button';
import { createSuccessSnackbar, createErrorSnackbar } from 'components/Snackbar';
import { closeModal } from 'components/Modal';
import When from 'components/When';

import { bem } from 'helpers/class-name';

import { messages } from './MFASetupModal.messages';

const { element } = bem('mfa-setup-modal');

const CopyRecoveryCodesStep = ({ recoveryCodes, isSetupConfirmation }) => {
  const dispatch = useDispatch();

  const handlePrintCodes = () => {
    window.print();
  };

  const handleCopytoClipboard = () => {
    const codesText = recoveryCodes.join('\n');
    try {
      navigator.clipboard.writeText(codesText);
      dispatch(createSuccessSnackbar(messages.codesCopiedToClipboard));
    } catch {
      dispatch(createErrorSnackbar(messages.codesCopiedToClipboardError));
    }
  };

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  return (
    <>
      <CardSection className={element('recovery-codes-wrapper')} flush>
        <When predicate={isSetupConfirmation}>
          <Message as="p" className={element('recovery-subtitle')} message={messages.mfaActiveSubtitle} />
        </When>
        <Message as="h3" className={element('recovery-save-code-title')} message={messages.saveCodesTitle} />
        <Message as="p" message={messages.saveCodesSubtitle} />
        <Message as="p" message={messages.saveCodesPrintInfo} />
        <div className={element('printable-section')}>
          <ul className={element('recovery-codes-list')}>
            {recoveryCodes.map(code => (
              <li key={code} className={element('recovery-code-item')}>
                {code}
              </li>
            ))}
          </ul>
        </div>
      </CardSection>
      <CardSection className={element('recovery-codes-buttons')} flush>
        <Button styled="primary-outline" type="button" onClick={handlePrintCodes}>
          <Message message={messages.printButton} />
        </Button>
        <Button styled="primary-outline" type="button" onClick={handleCopytoClipboard}>
          <Message message={messages.copyCodesButton} />
        </Button>
        <Button styled="primary" type="button" onClick={handleCloseModal}>
          <Message message={messages.closeButton} />
        </Button>
      </CardSection>
    </>
  );
};

CopyRecoveryCodesStep.propTypes = {
  recoveryCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  isSetupConfirmation: PropTypes.bool,
};

export default CopyRecoveryCodesStep;
